import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as dashboardSummaryAPI from '../../api/FinanceReportAPI/dashboardSummaryAPI';

// 1. Receivables (Client Outstanding Summary)
export const fetchClientOutStandingSummary = createAsyncThunk(
    'financialOverview/fetchClientOutStandingSummary',
    async ({ roleId, userId } = {}, { rejectWithValue }) => {
        try {
            const response = await dashboardSummaryAPI.getClientOutStandingSummary({ roleId, userId });
            return response?.Data || response;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch Client Outstanding Summary');
        }
    }
);

// 2. Payables (Vendor Outstanding Summary)
export const fetchVendorOutStandingSummary = createAsyncThunk(
    'financialOverview/fetchVendorOutStandingSummary',
    async ({ roleId, userId } = {}, { rejectWithValue }) => {
        try {
            const response = await dashboardSummaryAPI.getVendorOutStandingSummary({ roleId, userId });
            return response?.Data || response;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch Vendor Outstanding Summary');
        }
    }
);

// 3. Tax Liabilities (Stock Purchase Consolidate Summary - previous month GST)
export const fetchStockPurchaseConsolidateSummary = createAsyncThunk(
    'financialOverview/fetchStockPurchaseConsolidateSummary',
    async ({ roleId, userId } = {}, { rejectWithValue }) => {
        try {
            const response = await dashboardSummaryAPI.getStockPurchaseConsolidateSummary({ roleId, userId });
            return response?.Data || response;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch Stock Purchase Consolidate Summary');
        }
    }
);

const initialState = {
    receivables: null,
    payables: null,
    taxLiabilities: null,
    loading: {
        receivables: false,
        payables: false,
        taxLiabilities: false,
    },
    errors: {
        receivables: null,
        payables: null,
        taxLiabilities: null,
    },
};

const financialOverviewSlice = createSlice({
    name: 'financialOverview',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchClientOutStandingSummary.pending, (state) => {
                state.loading.receivables = true;
                state.errors.receivables = null;
            })
            .addCase(fetchClientOutStandingSummary.fulfilled, (state, action) => {
                state.loading.receivables = false;
                state.receivables = action.payload;
            })
            .addCase(fetchClientOutStandingSummary.rejected, (state, action) => {
                state.loading.receivables = false;
                state.errors.receivables = action.payload;
            })

            .addCase(fetchVendorOutStandingSummary.pending, (state) => {
                state.loading.payables = true;
                state.errors.payables = null;
            })
            .addCase(fetchVendorOutStandingSummary.fulfilled, (state, action) => {
                state.loading.payables = false;
                state.payables = action.payload;
            })
            .addCase(fetchVendorOutStandingSummary.rejected, (state, action) => {
                state.loading.payables = false;
                state.errors.payables = action.payload;
            })

            .addCase(fetchStockPurchaseConsolidateSummary.pending, (state) => {
                state.loading.taxLiabilities = true;
                state.errors.taxLiabilities = null;
            })
            .addCase(fetchStockPurchaseConsolidateSummary.fulfilled, (state, action) => {
                state.loading.taxLiabilities = false;
                state.taxLiabilities = action.payload;
            })
            .addCase(fetchStockPurchaseConsolidateSummary.rejected, (state, action) => {
                state.loading.taxLiabilities = false;
                state.errors.taxLiabilities = action.payload;
            });
    },
});

export const selectReceivablesSummary = (state) => state.financialOverview.receivables;
export const selectPayablesSummary = (state) => state.financialOverview.payables;
export const selectTaxLiabilitiesSummary = (state) => state.financialOverview.taxLiabilities;

export const selectReceivablesLoading = (state) => state.financialOverview.loading.receivables;
export const selectPayablesLoading = (state) => state.financialOverview.loading.payables;
export const selectTaxLiabilitiesLoading = (state) => state.financialOverview.loading.taxLiabilities;

export default financialOverviewSlice.reducer;
